import setAuctionType from '@/api/SetAuctionType';
import EasyPassServiceClient from '@/api/EasyPassServiceClient';
import store from '@/store';
import ApiError from '@/models/ApiError';
import EasyPassClient from './EasyPassClient';

class SavedAuctionClient {
  constructor(user) {
    this.easyPassClient = new EasyPassClient(user);
    this.easyPassServiceClient = new EasyPassServiceClient(user);
    this.rootUri = 'saved_auctions';
    this.easyPassRootUri = 'api/acvapi/v3';
    this.easyPassheaderSnake = {
      'json-naming-strategy': 'snake',
    };
  }

  getLaunchDetails({ savedAuctionId }) {
    return this.easyPassServiceClient.get(`launch/v1/${savedAuctionId}/details`, null, this.easyPassheaderSnake)
      .then((response) => response.data);
  }

  async launchAuction({
    id: savedAuctionId,
    vin,
    dealerId,
    autosell,
    floorPrice,
    greenLight,
    selectedRunLaneKey: lane,
    laneId,
    durationInSeconds,
    selectedAddressId,
    noReservePreviewLaneValue,
    titleOption,
    auctionStartTime,
    isScheduledAuctionInScheduledLane,
    startPrice,
    userId,
  }) {
    const data = {
      vin,
      dealer_id: dealerId,
      autosell,
      floor_price: floorPrice,
      green_light: greenLight,
      lane,
      lane_id: laneId,
      duration_in_seconds: durationInSeconds,
      address_id: selectedAddressId,
      title_option: titleOption,
      start_price: startPrice,
    };

    if (lane === 'no_reserve_preview') {
      data.auction_start_time = noReservePreviewLaneValue;
    } else if (lane === 'live_auction' || isScheduledAuctionInScheduledLane) {
      data.auction_start_time = auctionStartTime;
    }

    const shouldUseBulkEndpoint = await store.dispatch(
      'getFlag',
      store.state.featureFlags.featureFlagSlugs.launchUseBulkAuctionLaunchForSingleLaunch,
    );

    if (shouldUseBulkEndpoint) {
      data.saved_auction_id = savedAuctionId;
      data.source = 'single-launch-ui';
      data.requestor_user_id = userId;

      return this.easyPassServiceClient.post('launch/v1/bulk_auction_launch', [data], this.easyPassheaderSnake)
        .then((apiResponse) => {
          const response = apiResponse.data;
          if (apiResponse.status === 400) {
            throw new ApiError(response.data.responses[0].error_message[0], null);
          }
          if (apiResponse.status === 500) {
            const errorMessage = response.errors !== null ? response.errors[0]?.detail : 'No data returned from bulk auction launch.';
            throw new ApiError(errorMessage, null);
          }
          return response.data.responses[0];
        });
    }

    return this.easyPassServiceClient.post(`launch/v1/${savedAuctionId}/launch_auction`, data, this.easyPassheaderSnake)
      .then((response) => response.data);
  }

  async get({ savedAuctionId }) {
    const result = await this.easyPassClient.get(`${this.easyPassRootUri}/${this.rootUri}/${savedAuctionId}`);
    return result;
  }

  save(savedAuction) {
    const data = {
      vin: savedAuction.vin,
      green_light: savedAuction.greenLight,
      autosell: savedAuction.autosell,
      dealer_id: savedAuction.dealerId,
    };
    return this.easyPassClient.post(`${this.easyPassRootUri}/${this.rootUri}`, data);
  }

  async getList(params) {
    const useBff = await store.dispatch(
      'getFlag',
      store.state.featureFlags.featureFlagSlugs.showOffersOnSavedAuctionsScreen,
    );
    const url = useBff ? 'bff/saved_auctions'
      : `${this.easyPassRootUri}/saved_auctions`;

    return this.easyPassClient.get(url, params)
      .then((response) => setAuctionType(response, 'saved', 'saved_auctions'));
  }

  deleteSavedAuction(savedAuctionId) {
    return this.easyPassClient.delete(`${this.easyPassRootUri}/${this.rootUri}/${savedAuctionId}`);
  }
}

export default SavedAuctionClient;
